<template>
  <div class="text-center">

    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      top
      right
      :color="snackColor"
    >
      {{ snackMensaje }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import {mapState} from 'vuex'

  export default {
    data: () => ({
      timeout: 6000,
    }),
    computed: {
      ...mapState(['snackBar', 'snackMensaje', 'snackColor']),
      snackbar: {
        //getter
        get: function () {
          return this.$store.state.snackBar
        },
        // setter
        set: function (newVal){
            this.$store.state.snackBar = newVal
        }
        
      }
    },
  }
</script>